import { cn } from "@/lib/utils";
import { CheckCircleIcon, type Icon } from "@phosphor-icons/react";

/** One answer of a one-question step: a card, picked by clicking it. */
export function ChoiceCard({
  icon: IconComponent,
  title,
  description,
  selected,
  onClick,
}: {
  icon: Icon;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "relative flex w-full items-start gap-3 rounded-lg border p-4 text-left transition-colors",
        selected ? "border-primary bg-primary/5" : "hover:bg-muted/50",
      )}
    >
      <IconComponent
        className={cn(
          "mt-0.5 h-5 w-5 shrink-0",
          selected ? "text-primary" : "text-muted-foreground",
        )}
      />
      <span className="min-w-0 pr-6">
        <span className="block text-sm font-medium">{title}</span>
        <span className="text-muted-foreground block text-sm">
          {description}
        </span>
      </span>
      {selected && (
        <CheckCircleIcon
          className="text-primary absolute top-4 right-4 h-5 w-5"
          weight="fill"
        />
      )}
    </button>
  );
}
